// @ts-check
/** @typedef {import('../types/api').SiteSetting} SiteSetting */

import api from '../utils/apiClient';
import { assertArray, assertShape } from '../utils/apiGuards';

const adminSiteSettingsService = {
  /**
   * @returns {Promise<SiteSetting[]>}
   */
  getAllSettings: async () => {
    const data = await api.get('/api/site-settings/');
    assertArray(data, 'adminSiteSettingsService.getAllSettings');
    return data;
  },

  /**
   * @param {string} key
   * @returns {Promise<SiteSetting>}
   */
  getSetting: async (key) => {
    const data = await api.get(`/api/site-settings/${key}`);
    assertShape(data, ['key'], 'adminSiteSettingsService.getSetting');
    return data;
  },

  /**
   * @param {Object} settingData
   * @returns {Promise<SiteSetting>}
   */
  createSetting: async (settingData) => {
    return api.post('/api/site-settings/', settingData);
  },

  /**
   * @param {string} key
   * @param {Object} settingData
   * @returns {Promise<SiteSetting>}
   */
  updateSetting: async (key, settingData) => {
    return api.put(`/api/site-settings/${key}`, settingData);
  },

  /**
   * Upsert many settings at once. Backend route: POST /api/site-settings/bulk
   * with a flat { key: value } object (creates missing keys, updates existing).
   * @param {Record<string, string>} updates
   * @returns {Promise<SiteSetting[]>}
   */
  bulkUpdate: async (updates) => {
    const data = await api.post('/api/site-settings/bulk', updates);
    assertArray(data, 'adminSiteSettingsService.bulkUpdate');
    return data;
  },

  /**
   * @param {string} key
   * @returns {Promise<void>}
   */
  deleteSetting: async (key) => {
    return api.del(`/api/site-settings/${key}`);
  },
};

export default adminSiteSettingsService;
